import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useGetCurrentUserInfoQuery, useGetUserIdQuery, usePostUserChangeStatusMutation } from '../../store/api/userApi'
import { hideHoldDialog } from '../../store/slice/dialogSlice'
import {
  useGetRequestByInfoQuery,
  usePostRequestChangeDetailStatusMutation,
  usePostRequestChangeMainStatusMutation,
} from '../../store/api/requestApi'
import { MultilineTextBox } from '../TextBox'
import { useGetVendorCardQuery, usePostVendorChangeStatusMutation } from '../../store/api/vendorApi'
import { offRefreshButton, onRefreshButton } from '../../store/slice/buttonSlice'
import { showErrorToast, showSuccessToast } from '../../constToast/constToast'
import { useHoldComparisonChartMutation } from '../../store/api/bidComparsion'
import { usePostOrderChangeStatusMutation } from '../../store/api/orderApi'
import { usePostPaymentChangeStatusMutation } from '../../store/api/paymentApi'
import { head } from 'lodash'
import { usePostChangeInvoiceStatusMutation } from '../../store/api/invoiceApi'
import { updateRefetchData } from '../../store/slice/otherSlice'
import { updateSelectedMaterialData } from '../../store/slice/persistSlice'
import { updateUserData, updateVendorData } from '../../store/slice/mainToCardSlice'

const HoldDialog = ({ data, callback }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [comment, setComment] = useState('')

  const handleClose = () => {
    dispatch(hideHoldDialog())
    setComment('')
  }
  const open = useSelector((state) => state.dialogSlice.holdDialog)
  const url = useLocation().pathname

  const materialTableDataSlice = useSelector((state) => state.persistSlice.materialData)
  const userData = useSelector((state) => state.mainToCard.userData)
  const orderPersistData = useSelector((state) => state.persistSlice.orderPersistData)
  const requestDataSlice = useSelector((state) => state.persistSlice.requestData)
  const vendorData = useSelector((state) => state.mainToCard.vendorData)
  const selectedMaterialData = useSelector((state) => state.persistSlice.selectedMaterialData)
  const selectedBidComparsionGridData = useSelector((state) => state.bidComparsionSlice.selectedGridData)
  const selectedSequenceFromWFA = useSelector((state) => state.bidComparsionSlice.selectedSequenceFromWFA)
  const paymentDataSlice = useSelector((state) => state.persistSlice.paymentData)
  const paymentCardDataSlice = useSelector((state) => state.paymentSlice.paymentCardDataSlice)
  const paymentCardDataSliceHeader = paymentCardDataSlice?.header
  const buData = useSelector((state) => state.persistSlice.buData)
  const requestDetailsData =
    selectedMaterialData &&
    selectedMaterialData?.map((item) => ({ requestDetailId: item?.requestDetailId, sequence: item?.sequence }))
  const invoiceMain = useSelector((state) => state.mainToCard.invoiceMain)

  const { data: currentUserData } = useGetCurrentUserInfoQuery()

  const [addUserStatus] = usePostUserChangeStatusMutation()
  const [postChangeMainStatus, { isLoading: postChangeMainStatusLoading }] = usePostRequestChangeMainStatusMutation()
  const [postChangeDetailStatus, { isLoading: postChangeDetailStatusLoading }] =
    usePostRequestChangeDetailStatusMutation()
  const [postVendorChangeStatus] = usePostVendorChangeStatusMutation()
  const [holdBidComparison] = useHoldComparisonChartMutation()
  const [postChangePaymentStatus] = usePostPaymentChangeStatusMutation()
  const [postChangeInvoiceStatus] = usePostChangeInvoiceStatusMutation()

  let content, action, name

  useEffect(() => {
    dispatch(
      updateSelectedMaterialData([
        materialTableDataSlice?.find((item) => item?.lineNo == selectedMaterialData?.map((item) => item?.lineNo)),
      ])
    )
  }, [materialTableDataSlice])

  const handleRefresh = () => {
    dispatch(onRefreshButton())
    setTimeout(() => {
      dispatch(offRefreshButton(false))
    }, 1)
  }
  const { dataId } = useParams()
  const { data: userInfo } = useGetUserIdQuery(dataId)
  const { data: vendorInfo } = useGetVendorCardQuery(dataId)
  const { data: requestData } = useGetRequestByInfoQuery({
    requestMainId: dataId,
    businessUnitId: buData != null ? buData : currentUserData?.data?.defaultBusinessUnitId,
  })

  const orderData = useSelector((state) => state.mainToCard.orderData)
  const [postOrderChangeStatus] = usePostOrderChangeStatusMutation()

  const handlePostVendorChange = async () => {
    const data = await postVendorChangeStatus({
      vendorId: vendorData[0]?.vendorId,
      approveStatusId: 3,
      sequence: vendorData[0]?.sequence,
      comment: comment,
    })
    if (data?.data?.data) {
      showSuccessToast(`Succesfully`)
    } else {
      showErrorToast('Error')
      
    }
    setComment('')
    handleClose()
    handleRefresh()
    dispatch(updateVendorData([]));
  }

  const invoiceBuData = useSelector((state) => state.invoiceSlice.invoiceBuData)


  switch (url) {
    // USERS
    case '/users':
      name = <>{userData[0]?.userName}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button
          variant="contained"
          onClick={() => {
            addUserStatus([
              {
                id: userData[0]?.id,
                sequence: userData[0]?.sequence,
                approveStatus: 3,
                comment,
              },
            ])
            setComment('')
            handleClose()
            dispatch(updateUserData([]));
            showSuccessToast('Success')
          }}
        >
          Hold
        </Button>
      )
      break
    case `/users/${userInfo?.data?.id}`:
      name = <>{userInfo?.data?.userName}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button
          variant="contained"
          onClick={() => {
            addUserStatus([
              {
                id: userInfo?.data?.id,
                approveStatus: 3,
                comment,
                sequence: Number(localStorage.getItem('userSequence')),
              },
            ])
            navigate('/users')
            setComment('')
            handleClose()
            showSuccessToast('Success')
          }}
        >
          Hold
        </Button>
      )
      break

    // REQUESTS
    case '/requests':
      name = <>{requestDataSlice && requestDataSlice?.map((item) => item.requestNo).join(', ')}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button
          variant="contained"
          disabled={postChangeMainStatusLoading}
          onClick={async () => {
            const requestDataArray = requestDataSlice?.map((item) => ({
              requestMainId: item.requestMainId,
              requestNo: item.requestNo,
              sequence: item.sequence,
            }))

            const data = await postChangeMainStatus({
              requestDatas: requestDataArray,
              approveStatus: 3,
              comment,
              businessUnitName: requestDataSlice?.[0].businessUnitName,
            })

            if (data?.data?.statusCode === 200) {
              showSuccessToast('Succesfully')
            }

            handleRefresh()
            setComment('')
            handleClose()
          }}
        >
          Hold
        </Button>
      )
      break

    // PAYMENT
    case '/payment':
      name = <>{paymentDataSlice && paymentDataSlice?.map((item) => item.paymentRequestNo).join(', ')}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button
          variant="contained"
          onClick={async () => {
            const paymentDataArray = {
              payments: paymentDataSlice?.map((item) => ({
                paymentDocumentMainId: item.paymentDocumentMainId,
                sequence: item.sequence,
              })),
              approveStatus: 3,
              comment,
            }

            const data = await postChangePaymentStatus(paymentDataArray)

            if (data?.data?.statusCode === 200) {
              showSuccessToast('Succesfully')
            }

            handleRefresh()
            setComment('')
            handleClose()
          }}
        >
          Hold
        </Button>
      )
      break

    // Request Detail
    case `/requests/${requestData?.data?.requestMainId}`:
      name = <>Line No {selectedMaterialData && selectedMaterialData.map((item) => item?.lineNo).join(', ')}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button
          variant="contained"
          disabled={postChangeDetailStatusLoading}
          onClick={async () => {
            const data = await postChangeDetailStatus({
              requestDetails: requestDetailsData,
              approveStatus: 3,
              comment,
              businessUnitName: requestData?.data?.businessUnitName,
            })
            if (data?.data?.statusCode === 200) {
              showSuccessToast('Succesfully')
            }
            handleRefresh()
            setComment('')
            handleClose()
          }}
        >
          Hold
        </Button>
      )
      break

    // Vendors
    case '/vendors':
      name = <>{vendorData[0] ? vendorData[0]?.vendorName : ''}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button variant="contained" onClick={handlePostVendorChange}>
          Hold
        </Button>
      )
      break

    // Vendors
    case `/vendors/${vendorInfo?.data?.header?.vendorId}`:
      name = <>{vendorInfo?.data?.header?.vendorName}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button
          variant="contained"
          onClick={() => {
            postVendorChangeStatus({
              vendorId: vendorInfo?.data?.header?.vendorId,
              sequence: vendorInfo?.data?.header?.sequence,
              approveStatusId: 3,
              comment,
            })
            setComment('')
            handleClose()
            navigate('/vendors')
            showSuccessToast('Succesfully')
          }}
        >
          Hold
        </Button>
      )
      break
    case `/bid-comparison/${dataId}`:
      name = <>{selectedBidComparsionGridData?.[0]?.comparisonNo}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button
          variant="contained"
          onClick={() => {
            holdBidComparison({
              bidComparisonId: selectedBidComparsionGridData?.[0]?.bidComparisonId,
              sequence: selectedSequenceFromWFA,
              comment,
            })
            setComment('')
            handleClose()
            navigate('/bid-comparison')
            showSuccessToast('Successfully')
          }}
        >
          Hold
        </Button>
      )
      break

    // Orders
    case '/orders':
      name = <>{orderData[0]?.orderNo}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button
          variant="contained"
          onClick={() => {
            postOrderChangeStatus({
              orderMainId: orderData[0]?.orderMainId,
              approveStatusId: 3,
              sequence: orderData[0]?.sequence,
              comment: comment,
              rejectReasonId: null,
            })
            setComment('')
            handleClose()
            handleRefresh();
            dispatch(updateRefetchData())
            showSuccessToast('Succesfully')
          }}
        >
          Hold
        </Button>
      )
      break

    case `/orders/${dataId}`:
      name = <>{orderPersistData?.[0]?.orderNo}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button
          variant="contained"
          onClick={() => {
            postOrderChangeStatus({
              orderMainId: orderPersistData?.[0]?.orderMainId,
              approveStatusId: 3,
              sequence: orderPersistData?.[0]?.sequence,
              comment: comment,
              rejectReasonId: null,
            })

            setComment('')
            handleClose()
            dispatch(updateRefetchData())
            showSuccessToast('Succesfully')
            navigate('/orders')
          }}
        >
          Approve
        </Button>
      )
      break

    case '/invoice-register':
      name = <>{invoiceMain[0] && invoiceMain?.map(x => x.invoiceNo).join(', ')}</>
      content = <MultilineTextBox label="Comment" value={comment} setValue={setComment} rows="4" />
      action = (
        <Button
          variant="contained"
          onClick={async () => {
            const res = await postChangeInvoiceStatus({
              invoiceRegisterIds: invoiceMain?.map((item) => {
                return {
                  invoiceRegisterId: item?.invoiceRegisterId,
                  sequence: item?.sequence,
                  inMaxSequence: item?.inMaxSequence,
                  invoiceTypeId: item?.invoiceType,
                }
              }),
              approveStatus: 3,
              businessUnitId: invoiceBuData,
              comment,
            })
            setComment('')
            handleClose()
            handleRefresh()
            if (res?.data?.statusCode === 200) {
              showSuccessToast(`${invoiceMain[0] && invoiceMain?.map(x => x.invoiceNo).join(', ')} held`)
            } else {
              showErrorToast('Error')
            }
          }}
        >
          Hold
        </Button>
      )
      break
    default:
      content = null
      break
  }

  return (
    <div>
      <Dialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle>Hold {name}</DialogTitle>
        <Divider />
        <DialogContent>{content}</DialogContent>
        <DialogActions>
          {action}
          <Button variant="outlined" onClick={handleClose} sx={{ color: 'gray', borderColor: '#D3D3D3' }}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default HoldDialog